/* @flow */

import * as React from 'react';

import FeatureFlag from 'utils/FeatureFlag';

const TradingAccountDetails: React.StatelessFunctionalComponent<*> = (props: Object) => {
  // eslint-disable-next-line
  // const currency: string = `${ props.details.details.currency } \(${ props.details.details.currencySign }\)`;
  const tradingAccountDetails = [
    { id: 1, label: 'general:trading_accounts.labels.name', value: props.details.details.name },
    {
      id: 2,
      label: 'general:trading_accounts.labels.number',
      value: props.details.details.account_no,
    },
    {
      id: 3,
      label: 'general:trading_accounts.labels.legal_entity',
      value: props.details.details.er_company_code,
    },
  ];

  const t: Function = props.t;
  return (
    <React.Fragment>
      <h3>{t('general:trading_accounts.labels.details')}</h3>
      <table>
        <tbody>
          {tradingAccountDetails.map(item =>
            item.id === 3 ? (
              <FeatureFlag name="legalEntity" key={item.id}>
                <tr key={item.id}>
                  <td>
                    <b>{t(item.label)}:</b>
                  </td>
                  <td>{item.value}</td>
                </tr>
              </FeatureFlag>
            ) : (
              <tr key={item.id}>
                <td>
                  <b>{t(item.label)}:</b>
                </td>
                <td>{item.value}</td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </React.Fragment>
  );
};

export default TradingAccountDetails;
